import { create } from "zustand";

export type SyncState = "idle" | "syncing" | "error";

export interface SyncStore {
  isOnline: boolean;
  outboxSize: number;
  syncState: SyncState;
  lastError: string | null;

  setOnline: (online: boolean) => void;
  setOutboxSize: (n: number) => void;
  setSyncState: (s: SyncState, lastError?: string | null) => void;
}

const initialOnline =
  typeof navigator !== "undefined" && typeof navigator.onLine === "boolean"
    ? navigator.onLine
    : true;

export const useSyncStore = create<SyncStore>((set) => ({
  isOnline: initialOnline,
  outboxSize: 0,
  syncState: "idle",
  lastError: null,

  setOnline(online) {
    set({ isOnline: online });
  },
  setOutboxSize(n) {
    set({ outboxSize: n });
  },
  setSyncState(s, lastError = null) {
    set({ syncState: s, lastError });
  },
}));
